import {FormControl} from '@angular/forms';

const REGEX_PHONE_ISRAEL = /^(?:w|W)?(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/;
const REGEX_PHONE_USA = /^(?:w|W)?(?:1[-.\s]?)?(?:(\(\d{3}\))|(\d{3}))[-.\s]?(\d{3})[-.\s]?(\d{4})$/;
const REGEX_PHONE_INTERNATIONAL = /^(?:w|W)?\+(\d{1,3})[-.\s]?(\d{1,4})[-.\s]?(\d{1,4})[-.\s]?(\d{1,9})$/;

export enum PhoneNumberType {
	Israel,
	USA,
	International,
}

export function checkPhoneNumber(value: string): PhoneNumberType {
	const israel = new RegExp(REGEX_PHONE_ISRAEL);
	if (israel.test(value)) return PhoneNumberType.Israel;
	const usa = new RegExp(REGEX_PHONE_USA);
	if (usa.test(value)) return PhoneNumberType.USA;
	const international = new RegExp(REGEX_PHONE_INTERNATIONAL);
	if (international.test(value)) return PhoneNumberType.International;
	return undefined;
}

export function isValidPhoneNumber(value: string): boolean {
	return checkPhoneNumber(value) !== undefined;
}

/**
 * A validator that checks if the phone number is valid.
 * @param {FormControl} control - the control to validate
 * @returns {null | { phoneVaild: { value: boolean } }} - null if the phone number is valid, otherwise an object containing the error.
 */
export function phoneNUmberValidator(control: FormControl) {
	const phone_number = control.value;
	if (phone_number.isEmptyString()) return null;
	const result = checkPhoneNumber(phone_number);
	return result === undefined ? {phoneVaild: {value: result}} : null;
}
